import { baseQuery } from '../baseQuery';
import { type JsonDataItem } from 'types';

export const getAppointments = async ({
  startDate,
  selectionId,
  daysAmount,
  serviceType,
  techIds,
  customerId,
  suburb,
  duration,
  surroundingGeeks,
  searchId,
  skillIds,
}: JsonDataItem) => {
  const id = customerId ? `&customer_ID=${customerId}` : '';
  const skills = skillIds?.length ? skillIds.map((id: string) => (id !== '' ? `&skill_ID[]=${id}` : '')).join('') : '';
  const techs = techIds?.length ? techIds.map((id: number) => `&technician_ID[]=${id}`).join('') : '';

  const data = await baseQuery(
    `appointments?appointment_date=${startDate}&service_selection_id=${selectionId}&no_of_days=${daysAmount}&service_type=${serviceType}&suburb_ID=${suburb}${id}${techs}${skills}&duration=${duration}&surrounding_suburbs=${surroundingGeeks}&search_history_id=${searchId}`,
  );

  return data;
};
